import { render, staticRenderFns } from "./PessoaList.vue?vue&type=template&id=b947a3ba"
import script from "./PessoaList.vue?vue&type=script&lang=js"
export * from "./PessoaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports